import { StateService, StateParams } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";
import {ExportModel} from "../../models/export/ExportModel";
import {PagingCtrl} from "../PagingCtrl";
import {BaseEntity} from "../../entities/BaseEntity";

export class ExportCtrl<T extends BaseEntity> extends PagingCtrl<T>{
    public static $inject = ['$scope','$location','$state','$stateParams','ExportModel','NotificationService'];
    assignedGridOptions:any;
    constructor($scope:any, $location: ng.ILocationService, stateService:StateService,
                stateParamsService:StateParams, public exportModel:ExportModel<T>,
                notificationService:NotificationService) {
        super($scope, $location, stateService, stateParamsService, exportModel, notificationService);
        this.assignedGridOptions = {
            multiSelect:true,
            enableSorting:false,
            columnDefs:[],
            data:[],
            onRegisterApi:function(gridApi:any) {
                gridApi.selection.on.rowSelectionChanged($scope,function(row:any){
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if(row.isSelected)
                        $scope.vm.exportModel.addAssignedSelected(entity);
                    else
                        $scope.vm.exportModel.removeAssignedSelected(entity);
                });
                gridApi.selection.on.rowSelectionChangedBatch($scope,function(rows:any){
                    $.each(rows, (i, row) => {
                        var entity = row.entity;
                        if(row.isSelected)
                            $scope.vm.exportModel.addAssignedSelected(entity);
                        else
                            $scope.vm.exportModel.removeAssignedSelected(entity);
                    });
                });
            }
        };
        this.pagingModel.getColumnDefs().then(()=>{
            this.assignedGridOptions.columnDefs = this.setColumns();
        });
    }
    protected addItems():void{
        var itemsToAdd:T[] = [];
        for(var i=0;i<this.exportModel.selectedItems.length;i++){
            var found:boolean = false;
            var currentSelected:any = this.exportModel.selectedItems[i];
            for(var j=0;j<this.exportModel.assignedItems.length;j++){
                var currentAssigned = this.exportModel.assignedItems[j];
                if(currentSelected.id == currentAssigned.id)
                    found = true;
            }
            if(!found)
                itemsToAdd.push(currentSelected);
        }
        for(var i=0;i<itemsToAdd.length;i++){
            var currItem = itemsToAdd[i];
            this.assignedGridOptions.data.push(currItem);
        }
        this.exportModel.addItems(itemsToAdd);
    }
    protected removeItems():void{
        var toRemove:T[] = this.exportModel.selectedAssignedItems.slice(0);
        this.exportModel.removeItems(toRemove);
        for(var i=0;i<toRemove.length;i++){
            var currItem = toRemove[i];
            var indexToRemove = this.assignedGridOptions.data.indexOf(currItem);
            this.assignedGridOptions.data.splice(indexToRemove,1);
        }
    }
}
